import AXIOS from '@/axios-instance';

export default {
  retrieveProcessNames() {
    return AXIOS.get("/bpmn");
  },
  retrieveSurveysForProcess(uuid) {
    return AXIOS.get("/px/survey/bpmn/" + uuid);
  },
  deleteProcessModel(uuid) {
    return AXIOS.delete("/bpmn/" + uuid);
  },
  editFileName(uuid, fileName) {
    return AXIOS.put("/bpmn/" + uuid + "/filename", fileName);
  },
  changeProcessOwner(uuid, userId) {
    return AXIOS.put("/bpmn/" + uuid + "/initiator", userId)
  },
  editMngmtLink(uuid, mngmtLink) {
    return AXIOS.put("/bpmn/" + uuid + "/mngmtLink", mngmtLink)
  },
  editDocNr(uuid, docNr) {
    return AXIOS.put("/bpmn/" + uuid + "/docNr", docNr)
  },
  changeReleaseState(uuid, releaseState) {
    return AXIOS.put("/bpmn/" + uuid + "/releaseEnabled", releaseState, {
      headers: { "Content-Type": "application/json" }
    });
  },
  retrieveLastEditorForProcess(uuid) {
    return AXIOS.get("/bpmn/" + uuid + "/lastEditor");
  }
}